import { render, staticRenderFns } from "./VHeroBlock.vue?vue&type=template&id=9280332c&"
import script from "./VHeroBlock.vue?vue&type=script&lang=js&"
export * from "./VHeroBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports